import { useContext } from "react";
import RegistrationContext from "../contexts/RegistrationContext";
import Spinner from "../components/Spinner/Spinner";
import Registrations from "../admin-pages/Registrations/Registrations";
import Students from "../admin-pages/Students/Students";
import EurAI from "../admin-pages/EurAI/EurAI";
import Exhibitors from "../admin-pages/Exhibitors/Exhibitors";
import Visa from "../admin-pages/Visa/Visa";
import Codes2 from "../admin-pages/Codes/Codes2";
import Dashboard from "../admin-pages/Dashboard/Dashboard";
import Papers from "../admin-pages/Papers/Papers";
import Exports from "../admin-pages/Exports/Exports";
import Press from "../admin-pages/Press/Press";
import Workshops from "../admin-pages/WorkshopTutorials/WorkshopsTutorials";
import Cancellations from "../admin-pages/Cancellations/Cancellations";

const AdminUser = () => {
  const {
    screen,
    loading,
  
  } = useContext(RegistrationContext);

  const isFullWidth = ["admin-dashboard", "admin-registrations", "admin-codes", "admin-workshops", "admin-student", "admin-eurai", "admin-exhibitors", "admin-cancellations", "admin-press", "admin-visa"].includes(screen);
  const wrapperClass = isFullWidth
    ? "w-full flex-1 flex flex-col"
    : "container px-4 flex-1 flex flex-col";

  return (
    <div className={wrapperClass}>

      {loading ? (
        <div className="flex justify-center h-full items-center">
          <Spinner />
        </div>
      ) : (
        <>
          {screen === "admin-dashboard" && <Dashboard />}
          {screen === "admin-student" && <Students />}
          {screen === "admin-eurai" && <EurAI />}
          {screen === "admin-workshops" && <Workshops />}
          {screen === "admin-registrations" && <Registrations />}
          {/* Uncomment the following line when the component is ready */}
          {screen === "admin-visa" && <Visa />}
          {screen === "admin-paper" && <Papers />}
          {screen === "admin-codes" &&  <Codes2 />}
          {screen === "admin-exhibitors" && <Exhibitors />}
          {screen === "admin-press" && <Press />}
          {screen === "admin-exports" && <Exports />}
          {screen === "admin-cancellations" && <Cancellations />}

          {/* {screen === "admin-registrations" && <Registrations />} */}

        </>
      )}

    </div>
  );
};

export default AdminUser;
